module.exports = __webpack_public_path__ + "static/media/pagarbook.c3662d8b.svg";